import { createSlice } from '@reduxjs/toolkit'
import {
  filterStatusDetailsEmployeesList,
  retrieveBatchStatusDetailsByID,
  retrieveStatusDetailsEmployeesByID,
  searchStatusDetailsEmployeesList,
  sortStatusDetailsEmployeesList,
  statusDetailsEmployeesListPagination,
  userBatchStatusDetailsResetAlertHandler,
} from './userBatchStatusDetailsThunk'

const defaultPageSize = 50
const defaultActiveSummary = 'ALL'

const initialState = {
  loading: false,
  alert: {},
  pageNumber: 0,
  summaries: {},
  sortBy: [],
  activeSort: {},
  filterList: [],
  activeFilters: [],
  pageSize: defaultPageSize,
  activeSummary: defaultActiveSummary,
  activeSearch: '',
  data: [],
  lookups: {},
  updatedItem: {},
  sideBar: {},
  finalPage: true,
  batchStatusDetails: {},
  batchId: 0,
}

const userBatchStatusDetailsSlice = createSlice({
  name: 'userBatchStatusDetails',
  initialState,
  extraReducers: {
    [userBatchStatusDetailsResetAlertHandler.fulfilled]: (state) => {
      state.alert = {}
    },
    [retrieveBatchStatusDetailsByID.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [retrieveBatchStatusDetailsByID.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [retrieveBatchStatusDetailsByID.fulfilled]: (state, { payload }) => {
      state.batchStatusDetails = payload.data
      state.loading = false
      state.alert = {}
    },
    [retrieveStatusDetailsEmployeesByID.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [retrieveStatusDetailsEmployeesByID.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [retrieveStatusDetailsEmployeesByID.fulfilled]: (state, { payload }) => {
      state.data = payload.response.users
      state.batchId = payload.batchId
      state.summaries.all = payload.response.metadata.all
      state.sortBy = payload.response.sort
      state.filterList = payload.response.facets.status
      state.finalPage = payload.response.users?.length < state.pageSize
      state.activeSort = payload.response.sort[0] || {}
      state.activeFilters = []
      state.updatedItem = {}
      state.pageNumber = 0
      state.loading = false
      state.alert = {}
      state.activeSearch = ''
    },
    [filterStatusDetailsEmployeesList.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [filterStatusDetailsEmployeesList.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [filterStatusDetailsEmployeesList.fulfilled]: (state, { payload }) => {
      state.activeFilters = payload.filter
      state.data = payload.response.users
      state.summaries.all = payload.response.metadata.all
      state.sortBy = payload.response.sort
      state.filterList = payload.response.facets.status
      state.finalPage = payload.response.users?.length < state.pageSize
      state.pageNumber = 0
      state.loading = false
      state.alert = {}
    },
    [sortStatusDetailsEmployeesList.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [sortStatusDetailsEmployeesList.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [sortStatusDetailsEmployeesList.fulfilled]: (state, { payload }) => {
      state.activeSummary = payload.summary
      state.data = payload.response.users
      state.summaries.all = payload.response.metadata.all
      state.sortBy = payload.response.sort
      state.filterList = payload.response.facets.status
      state.finalPage = payload.response.users?.length < state.pageSize
      state.pageNumber = 0
      state.loading = false
      state.alert = {}
      state.activeSort = payload.sort
    },
    [searchStatusDetailsEmployeesList.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [searchStatusDetailsEmployeesList.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [searchStatusDetailsEmployeesList.fulfilled]: (state, { payload }) => {
      state.activeSearch = payload.search
      state.data = payload.response?.users
      state.summaries.all = payload.response.metadata.all
      state.finalPage = payload.response.users?.length < state.pageSize
      state.pageNumber = 0
      state.loading = false
      state.alert = {}
      state.filterList = payload.response.facets.status
    },
    [statusDetailsEmployeesListPagination.pending]: (state) => {
      state.loading = true
      state.alert = {}
    },
    [statusDetailsEmployeesListPagination.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [statusDetailsEmployeesListPagination.fulfilled]: (state, { payload }) => {
      state.data = payload.response.users
      state.summaries.all = payload.response.metadata.all
      state.sortBy = payload.response.sort
      state.filterList = payload.response.facets.status
      state.finalPage = payload.response.users?.length < state.pageSize
      state.pageNumber = payload.pageNumber
      state.loading = false
      state.alert = {}
    },
  },
})

export const selectUserBatchStatusDetails =
({ userBatchStatusDetails }) => userBatchStatusDetails
export default userBatchStatusDetailsSlice.reducer
